/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Work_Order_Import_FailedInputs */

const en_work_order_import_failed = /** @type {(inputs: Work_Order_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`External Work Order Import Failed. ${i?.message}`)
};

const fr_work_order_import_failed = /** @type {(inputs: Work_Order_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de l’importation de l’ordre de travail externe. ${i?.message}`)
};

const de_work_order_import_failed = /** @type {(inputs: Work_Order_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import externer Arbeitsaufträge fehlgeschlagen. ${i?.message}`)
};

const it_work_order_import_failed = /** @type {(inputs: Work_Order_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importazione ordine di lavoro esterno non riuscita. ${i?.message}`)
};

const ru_work_order_import_failed = /** @type {(inputs: Work_Order_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Импорт внешнего заказа на выполнение работ не удался. ${i?.message}`)
};

const es_work_order_import_failed = /** @type {(inputs: Work_Order_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en la importación de la orden de trabajo externa. ${i?.message}`)
};

const zh_cn2_work_order_import_failed = /** @type {(inputs: Work_Order_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`外部工单导入失败。${i?.message}`)
};

const ja_work_order_import_failed = /** @type {(inputs: Work_Order_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`外部作業指示書のインポートに失敗しました。${i?.message}`)
};

const hi_work_order_import_failed = /** @type {(inputs: Work_Order_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`बाह्य कार्य आदेश आयात विफल। ${i?.message}`)
};

const pt_pt2_work_order_import_failed = /** @type {(inputs: Work_Order_Import_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A importação da ordem de serviço externa falhou. ${i?.message}`)
};

/**
* | output |
* | --- |
* | "External Work Order Import Failed. {message}" |
*
* @param {Work_Order_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_failed = /** @type {((inputs: Work_Order_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_import_failed(inputs)
	if (locale === "de") return de_work_order_import_failed(inputs)
	if (locale === "it") return it_work_order_import_failed(inputs)
	if (locale === "ru") return ru_work_order_import_failed(inputs)
	if (locale === "es") return es_work_order_import_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_import_failed(inputs)
	if (locale === "ja") return ja_work_order_import_failed(inputs)
	if (locale === "hi") return hi_work_order_import_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_import_failed(inputs)
	return en_work_order_import_failed(inputs)
});